import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useNavigation, useSearchParams } from 'react-router-dom';
import URL from '../constants/ServerUrl';

const Users = () => {
  const [search, setSearch] = useState('');
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate=useNavigate();

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${URL}user`);
      setIsLoading(false);
      setUserData(response.data);
      console.log(response.data);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const filteredUsers = userData.filter((user) =>
    user.contactPerson && user.contactPerson.toLowerCase().startsWith(search.toLowerCase())
);

  return (
    <div className="container mx-auto p-4">

<h1 className="text-2xl font-bold text-center text-blue-600 mb-6">Users</h1>
      <input
        type="text"
        placeholder="Search by user name"
        value={search}
        onChange={handleSearch}
        className="w-full px-4 py-2 mb-4 bg-white border border-gray-300 rounded"
      />

<button
        className="bg-green-500 text-white px-4 py-2 rounded"
        onClick={() => navigate(`AddUser`)}
      >
        Add New User
      </button>

      {isLoading ? (
        <div className="text-center my-4">
          <p className="text-2xl">Loading Users...</p>
        </div>
      ) : filteredUsers.length === 0 ? (
        <div className="text-center my-4">
          <p className="text-2xl">No Users Found</p>
        </div>
      ) : (
        <ul>
          {filteredUsers.map((user) => (
            <li key={user._id} className="my-4 p-4 bg-gray-100 rounded">
              <p>{user.userId}</p>
              <div className="flex items-center justify-between">
                <div>
                  <p>{user.contactPerson}</p>
                  <p className="text-gray-500">{user.username}</p>
                </div>
                <div>
                  <p
                          onClick={() => navigate(`EditUser?username=${user.username}`)}
                    className="text-blue-500 cursor-pointer"
                  >
                    Edit
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}

      
    </div>


  );
};

export default Users;